// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollDownAction(60, 'scroll');
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
		const preload = document.getElementById('preload-intro'); 

		if (preload) {
			setTimeout(() => {
				preload.querySelector('.preloading__image')
					.classList.add('animated');
			}, 400);

			setTimeout(() => {
				preload.classList.add('hidde');
				document.body.classList.remove('is-loading');
				document.body.classList.add('is-loaded');
				preload.setAttribute('aria-hidden', 'true');
			}, 3000);
		}
		// mobile preloading 

		function getMobilePreloadElement() {
			const viewportWidth = window.innerWidth;

			if (viewportWidth < 600) {
				const preloadElement = document.getElementById('preload-intro__mobile');
				if (preloadElement) {
				console.log("Mobile preload element found.");
					setTimeout(() => {
						preloadElement.classList.add('hidde');
					}, 3000);
				}
			}
		}
		getMobilePreloadElement();
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

		// Lenguage nav Value
	let lenguageSelect = document.querySelector('[for="select_languaje"]');
	let url = window.location.href.split('/');
	let lenguage = url[3];

	if(lenguageSelect != null) {
		switch(lenguage) {
			case 'es':
				lenguageSelect.innerHTML = 'ES';
			break;
			default:
				lenguageSelect.innerHTML = 'EN';
			break;
		}
	}

		//email signup animation 
//CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
		for(let j = 0; j < allffields.length; j++){
			
			if(allffields[j].getElementsByTagName('input').length > 0){
				if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
					allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
						this.parentElement.classList.add('moved');
					})
				}
			}
			if(allffields[j].getElementsByTagName('select').length > 0){
				allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
					this.parentElement.classList.add('moved');
				})
			}
			if(allffields[j].getElementsByTagName('textarea').length > 0){
				allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
					this.parentElement.classList.add('moved');
				})
			}
		}
	}

	// accordion 
	let allAccordionItems = document.getElementsByClassName('js-accordion-title');
	let allALength = allAccordionItems.length;

	for(let i =0; i < allALength; i++){
		allAccordionItems[i].addEventListener('click', function(){
			let currentParent = this.parentElement;
			let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
			let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0];
			if(currentParent.classList.contains('open')){
				currentParent.classList.remove('open');
				currentCopy.style.height = '0';
			} else {
				currentParent.classList.add('open');
				currentCopy.style.height = currentCopyHeight + 'px';
			}
		})
	}

		/// menu  mobile ////
	let openMenu = document.getElementById("burgerMenu");
	if( openMenu ){
		openMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.add("active");
		});
	}

	let closeMenu = document.querySelector(".close-menu");
	if(closeMenu){
		closeMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.remove("active");
		});
	}

	let mobileNav = document.querySelector(".js-navigation ul:not(.social-media)");
	if(mobileNav != null) {
		mobileNav.addEventListener("click", (e) => {
			let target = e.target.closest("li");
	
			if (!target)
				return;
	
			target.classList.toggle("active");
		});
	}

	//PARALLAX EFFECT
	const observers_parallax = document.querySelectorAll(".js-parallax-element");

	if (observers_parallax.length > 0) {
		const activeScrollHandlers = {};
		const handler_parallax = (entries) => {
			entries.forEach(entry => {
				const el = entry.target;
				const id = el.dataset.parallaxid;

				if (entry.isIntersecting) {
					activeScrollHandlers[id] = () => doParallax(el);
					window.addEventListener('scroll', activeScrollHandlers[id]);
				} else {
					window.removeEventListener('scroll', activeScrollHandlers[id]);
					delete activeScrollHandlers[id];
				}
			});
		};

		const observer = new IntersectionObserver(handler_parallax, { threshold: 0 });

		observers_parallax.forEach((element, index) => {
			element.dataset.parallaxid = index; 
			observer.observe(element);
		});
	}
})();

function doParallax(el) {
    const parent = el.closest('.slider');
    const parentOffsetTop = parent.offsetTop;
    const scroll = window.pageYOffset;
    const relativeScroll = scroll - parentOffsetTop;
    const speed = parseFloat(el.dataset.parallax.split(',')[0]) || -20;
    const yPos = relativeScroll * (speed / 100);
    el.style.backgroundPositionY = `${yPos}px`;
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
// The Neighborhood main nav fix
function updateNeighborhoodLink() {
  if (document.documentElement.lang === 'es') {
    const navSelector = 'ul#privary-navigation li.privary-navigation__item.primary-nav-5 a';
    const linkElement = document.querySelector(navSelector);
    if (linkElement) {
      linkElement.textContent = 'El barrio';
    }
  }
}
updateNeighborhoodLink();